import React, { useEffect, useRef, useState } from 'react'
import { CButton, CFormLabel, CModal, CModalBody, CModalFooter, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import SaveExtra from '../../services/general/saveExtraData.api'
import Graytextarea from '../../components/Graytextarea'
import { FilePlus2 } from 'lucide-react'
import HighLightText from './HighLightText'
import { getAllAppointmentsDetails } from './appointmentFilterData'
import AppSelect from './AppSelect'
 
import { usePatientStatus } from '../../hooks/usecheckForUpdate'
import { checkIfDataAvailableData, convertDate } from '../../utils/checkForUpdateUtils'

// const FormQuestionRender = ({  patientID = '', patientData, noteID,  patientDiagnosis }) => {
const FormQuestionRender = ({ patientID = '', patientData, noteID = 0, patientDiagnosis, callingName = '' }) => {
    const [fetchingQuestions, setFetchingQuestions] = useState(false)

    const [freeTypes, setFreeTypes] = useState({})

    const [questionsWithDiagnosis, setQuestionsWithDiagnosis] = useState({})
    const [patientFinalNoteHpi, setPatientFinalNoteHpi] = useState({})
    const [saving, setSaving] = useState(false)

    const noteStructureRef = useRef()

    const [freeTypeModal, setFreeTypeModal] = useState(false)
    const [newFreeTypeText, setNewFreeTypeText] = useState('')
    const [tempFreeTypeText, setTempFreeTypeText] = useState('')
    const [selectedDiagnosiToAddFreeTypeRemarks, setSelectedDiagnosiToAddFreeTypeRemarks] = useState('')
    const [freeTypeRemarksText, setFreeTypeRemarksText] = useState('')
   const { updatePatientData } = usePatientStatus()

    console.log( questionsWithDiagnosis, 'determine issue')

    const selectClassName = 'basic-single-select ui-form-question-select'
    const questionShellClassName = callingName === 'callcenter'
        ? 'ui-form-question-shell ui-form-question-shell--callcenter'
        : 'ui-form-question-shell'

    const handleCallCenterPaste = (event) => {
        if (callingName !== 'callcenter') return

        event.preventDefault()
        const plainText = event.clipboardData?.getData('text/plain') || ''

        if (document.execCommand?.('insertText', false, plainText)) return

        const selection = window.getSelection()
        if (!selection?.rangeCount) return

        const range = selection.getRangeAt(0)
        range.deleteContents()
        range.insertNode(document.createTextNode(plainText))
        range.collapse(false)
        selection.removeAllRanges()
        selection.addRange(range)
        event.currentTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }

    const createQuestionPathSegment = (item, index, optionLabel = '') => ({
        id: item?.id ?? null,
        index,
        optionLabel,
    })

    const getQuestionPathKey = (path = []) =>
        path
            .map(({ id, index, optionLabel }) => `${optionLabel || 'root'}:${id ?? 'no-id'}:${index}`)
            .join('|')

    const matchesQuestionPathSegment = (question, index, segment) => {
        const idMatches = segment.id === null || question?.id === segment.id
        return index === segment.index && idMatches
    }

    const questionIdsMatch = (answer, question) => {
        const answerId = answer?.id
        const questionId = question?.id

        if (answerId === questionId) return true
        if (answerId === null || answerId === undefined || questionId === null || questionId === undefined) return false

        return String(answerId) === String(questionId)
    }

    const findAnsweredMatch = (answered, question, questionInstanceKey) =>
        answered.find((answer) => answer?.questionInstanceKey && answer.questionInstanceKey === questionInstanceKey) ||
        answered.find((answer) => !answer?.questionInstanceKey && answer.label === question.label && questionIdsMatch(answer, question))

    const getDiagnosisRemarkFromQuestions = (questions = []) => {
        if (!Array.isArray(questions)) return ''

        const questionWithRemark = questions.find((question) => question?.freewayRemark)
        return questionWithRemark?.freewayRemark || ''
    }

    const getDiagnosisRemarkText = (diagnosisName, questions = questionsWithDiagnosis?.[diagnosisName]) => {
        if (!diagnosisName) return ''

        const savedRemark = freeTypes?.[diagnosisName]
        return savedRemark ?? getDiagnosisRemarkFromQuestions(questions)
    }

    const openDiagnosisRemarkModal = (diagnosisName, questions = []) => {
        setFreeTypeRemarksText(getDiagnosisRemarkText(diagnosisName, questions))
        setSelectedDiagnosiToAddFreeTypeRemarks(diagnosisName)
    }

    const closeDiagnosisRemarkModal = () => {
        setSelectedDiagnosiToAddFreeTypeRemarks('')
        setFreeTypeRemarksText('')
    }

    const handleSaveDiagnosisRemark = () => {
        const diagnosisName = selectedDiagnosiToAddFreeTypeRemarks
        const remarkText = freeTypeRemarksText || ''

        if (!diagnosisName) return

        setFreeTypes((prev) => ({
            ...prev,
            [diagnosisName]: remarkText,
        }))

        setQuestionsWithDiagnosis((prevData) => {
            const currentQuestions = Array.isArray(prevData[diagnosisName]) ? prevData[diagnosisName] : []
            const updatedQuestions =
                currentQuestions.length > 0
                    ? currentQuestions.map((question, questionIndex) =>
                          questionIndex === 0 ? { ...question, freewayRemark: remarkText } : question,
                      )
                    : [
                          {
                              id: Date.now(),
                              label: '',
                              answer: '',
                              condition: null,
                              type: 'text',
                              isMultiple: false,
                              toolTipValue: '',
                              options: [],
                              freeType: '',
                              showFreeTypeInAssessment: false,
                              freewayRemark: remarkText,
                              isOptionForFreeType: true,
                          },
                      ]

            return {
                ...prevData,
                [diagnosisName]: updatedQuestions,
            }
        })

        closeDiagnosisRemarkModal()
    }



    const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
        console.log(allPatientHpiData, 'allPatientHpiData')
        const filtered = allPatientHpiData.filter((item) => {
            const patientData = item[patientID]
            // /  return patientData && patientData[noteID]
            return patientData
        })
        console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

        const latest = filtered.at(-1)
        console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
        return latest || null
    }


    console.log(questionsWithDiagnosis, 'questionsWithDiagnosis')

    const getQuestionForDiagnosis = async (hpiData = null) => {
        console.log(hpiData, 'hpiData in getQuestionForDiagnosis')
        setFetchingQuestions(true)

        try {
            let diagnosisData = await GetDiagnosisData('')
            diagnosisData = JSON.parse(diagnosisData?.d)?.Data || []

            const currentHpiData = hpiData || patientFinalNoteHpi
            const findDiagnosisIids = diagnosisData.filter((item) => patientDiagnosis?.includes(item?.Name))
            const structured = {}
            const freeTypeAllDiagnosis = {}
            console.log("all call center data " , findDiagnosisIids , diagnosisData , )
  
            if (findDiagnosisIids?.length > 0) {
                await Promise.all(
                    findDiagnosisIids.map(async (diagnos) => {

                       console.log("free type global", diagnos)

                        let data = await SaveQuestionProvider('GET', '', 'Call Center', diagnos.id, '')

                        data = JSON.parse(data?.d)?.Data || []

                        const questions = data
                            .map((q) => {
                                try {
                                    return JSON.parse(q.questionData)
                                } catch (e) {
                                    return []
                                }
                            })
                            .flat()

                        console.log(currentHpiData, 'currentHpiData in getQuestionForDiagnosis')

                        const answered = Array.isArray(currentHpiData?.[diagnos.Name]) ? currentHpiData[diagnos.Name] : []

                        console.log('answered data ', answered,questions)

                        // if (answered.length > 0 && answered[0]?.freewayRemark) {
                        //   console.log(diagnos?.Name,answered[0]?.freewayRemark || freeTypes[diagnos?.Name] || '',"determine issue 3")
                        //   freeTypeAllDiagnosis[diagnos?.Name] = answered[0]?.freewayRemark || freeTypes[diagnos?.Name] || ''
                        // }
                        const remark =
                            answered.length > 0 && answered[0]?.freewayRemark
                                ? answered[0].freewayRemark
                                : freeTypes[diagnos?.Name] || '';

                        freeTypeAllDiagnosis[diagnos?.Name] = remark;

                            console.log("remarks Data",  remark)
                        // const updateQuestionsWithAnswer = (questionsList, parentLabel = '') => {
                        //     return questionsList.map((q) => {
                        //         const match = answered.find((a) => a.label === q.label && a.id == q.id)
                          
                        //         const updatedQuestion = {
                        //             ...q,
                        //             // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                        //             historyOfDiagnosis: q?.historyOfDiagnosis || false,
                        //             freewayRemark: q?.freewayRemark || '',
                        //             answer: match?.answer || '',
                        //             freeType: match?.freeType || '',
                        //             parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                        //         }
                        //         console.log("updatedQuestion",updatedQuestion)
                        //         // If selected option has linkedQuestion, update it too
                        //         if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                        //             updatedQuestion.options = updatedQuestion.options.map((opt) => {
                        //                 if (opt.label === updatedQuestion.answer && opt.linkedQuestion?.length > 0) {
                        //                     return {
                        //                         ...opt,
                        //                         linkedQuestion: updateQuestionsWithAnswer(opt.linkedQuestion, updatedQuestion.label),
                        //                     }
                        //                 }
                        //                 return opt
                        //             })
                        //         }

                        //         return updatedQuestion
                        //     })
                        // }
                          const updateQuestionsWithAnswer = (questionsList, parentLabel = '', parentPath = [], optionLabel = '') => {
              return questionsList.map((q, index) => {
                const currentPath = [...parentPath, createQuestionPathSegment(q, index, optionLabel)]
                const questionInstanceKey = getQuestionPathKey(currentPath)
                const match = findAnsweredMatch(answered, q, questionInstanceKey)
                console.log('questionsList', match)
                const updatedQuestion = {
                  ...q,
                  // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                  historyOfDiagnosis: q?.historyOfDiagnosis || false,
                  questionInstanceKey,
                  freewayRemark: match?.freewayRemark || q.freewayRemark || '',
                  answer: match?.answer || '',
                  freeType: match?.freeType || '',
                  parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                }



                if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                  updatedQuestion.options = updatedQuestion.options.map((opt) => {
                    const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

                    if (opt.label === updatedQuestion.answer && linkedQuestions.length > 0) {
                      return {
                        ...opt,
                        linkedQuestion: updateQuestionsWithAnswer(linkedQuestions, updatedQuestion.label, currentPath, opt.label),
                      }
                    }

                    return opt
                  })
                }



                return updatedQuestion
              })
            }
                        console.log("questionData",questions )
                        const mergedQuestions = updateQuestionsWithAnswer(questions)
                        console.log("mergedQuestions",mergedQuestions )
                        structured[diagnos.Name] = mergedQuestions

                    }),
                )
            }
           
            setFreeTypes(freeTypeAllDiagnosis)
            // setQuestionsWithDiagnosis(structured)
            setQuestionsWithDiagnosis((prev) => {
                const merged = { ...prev }

                Object.entries(structured).forEach(([diagnosisName, questions]) => {
                    if (!merged[diagnosisName]) {
                        merged[diagnosisName] = questions
                    }
                })

                return merged
            })
        } catch (error) {
            console.error('Error in getQuestionForDiagnosis:', error)
        } finally {
            setFetchingQuestions(false)
        }
    }
  console.log("mergeQuestionData", questionsWithDiagnosis)
    const getQuestionForNewlyDiagnosis = async (selectedDiagnosisIds) => {
        // setFetchingQuestions(true);

        try {
            let diagnosisData = await GetDiagnosisData('')
            diagnosisData = JSON.parse(diagnosisData?.d)?.Data || []

            const tempIds = noteStructureRef.current?.metadata?.tempIds || []
            const followupIds = noteStructureRef.current?.metadata?.diagnosisIds || []

            // Filter diagnosis based on the selected IDs
            const findDiagnosisIids = diagnosisData.filter((item) => selectedDiagnosisIds.includes(item.id))

            const newQuestionsData = {}

            if (findDiagnosisIids?.length > 0) {
                await Promise.all(
                    findDiagnosisIids.map(async (diagnos) => {




                        let data = await SaveQuestionProvider('GET', '', 'Call Center', diagnos.id, '')
                        data = JSON.parse(data?.d)?.Data || []

                        const questions = data
                            .map((q) => {
                                try {
                                    return JSON.parse(q.questionData)
                                } catch (e) {
                                    return []
                                }
                            })
                            .flat()

                        // Get existing answers for this diagnosis if any
                        const answered = Array.isArray(patientFinalNoteHpi?.[diagnos.Name]) ? patientFinalNoteHpi[diagnos.Name] : []

                        const updateQuestionsWithAnswer = (questionsList, parentLabel = '', parentPath = [], optionLabel = '') => {
                            return questionsList.map((q, index) => {
                                const currentPath = [...parentPath, createQuestionPathSegment(q, index, optionLabel)]
                                const questionInstanceKey = getQuestionPathKey(currentPath)
                                const match = findAnsweredMatch(answered, q, questionInstanceKey)
                                const updatedQuestion = {
                                    ...q,
                                    // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                                    historyOfDiagnosis: match?.historyOfDiagnosis || false,
                                    questionInstanceKey,
                                    freewayRemark: match?.freewayRemark || '',
                                    answer: match?.answer || '',
                                    freeType: match?.freeType || '',
                                    parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                                }

                                // Handle linked questions for options
                                if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                                    updatedQuestion.options = updatedQuestion.options.map((opt) => {
                                        const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

                                        if (opt.label === updatedQuestion.answer && linkedQuestions.length > 0) {
                                            return {
                                                ...opt,
                                                linkedQuestion: updateQuestionsWithAnswer(linkedQuestions, updatedQuestion.label, currentPath, opt.label),
                                            }
                                        }
                                        return opt
                                    })
                                }

                                return updatedQuestion
                            })
                        }

                        const mergedQuestions = updateQuestionsWithAnswer(questions)
                        newQuestionsData[diagnos.Name] = mergedQuestions


                    }),
                )
            }

            // Merge new questions with existing questions
            setQuestionsWithDiagnosis((prevData) => ({
                ...prevData,
                ...newQuestionsData,
            }))
        } catch (error) {
            console.error('Error in getQuestionForNewlyDiagnosis:', error)
        } finally {
            // setFetchingQuestions(false);
        }
    }

    const fetchPatientFinalNoteDetails = async () => {
        try {
            let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
            let allData = JSON.parse(data?.d)

            console.log('patinet id  allData ', allData)
            const allPatientHpiData = allData?.Data?.map((item) => {
                return {
                    ...JSON.parse(item?.JsonData),
                    CreatedAt: item?.CreatedAt,
                }
            })

            const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)

            console.log(result, 'allPatientHpiData', patientID)


            //   setSubjective(result[patientID])

            console.log(result?.[patientID], 'result?.[patientID]?.[noteID]')

            try {
                const hpiData = result?.[patientID]?.CCENTER || {}
                // const newFreeTypeTextFetched = result?.[patientID]?.[noteID]?.newFreeTypeText || ''

                // if (newFreeTypeTextFetched) {
                //   setNewFreeTypeText(newFreeTypeTextFetched || '')
                //   setTempFreeTypeText(newFreeTypeTextFetched || '')
                // }
                setPatientFinalNoteHpi(hpiData)
                setNewFreeTypeText(result?.[patientID]?.globalFreeType || '')
                setTempFreeTypeText(result?.[patientID]?.globalFreeType || '')
                // await getQuestionForDiagnosis(hpiData) //it will reload the data loading set, when new diagnosis added ig isssue
                return hpiData
            } catch (error) {
                console.error('Error setting patient CCENTER:', error)
                setPatientFinalNoteHpi({})
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        const fetchHpiAndQuestions = async () => {
            const hpidata = await fetchPatientFinalNoteDetails()
            console.log("fetchPatientFinalNoteDetails", hpidata)
            await getQuestionForDiagnosis(hpidata)
        }
        fetchHpiAndQuestions()
    }, [patientDiagnosis])

    console.log(questionsWithDiagnosis, 'questionsWithDiagnosis')

    // const collectAllAnsweredQuestionsFromMerged = (questions, parentContext = null, onlyWithHistoryOfDiagnosis = false) => {
    //     const result = []

    //     for (const q of questions) {
    //         const { answer, freeType, label, options = [], id , type } = q
    //         console.log('answer data ', answer,  q)
    //         const hasAnswer = Array?.isArray(answer) ? answer?.join(',')?.trim() : answer?.trim()

    //         const hasFreeType = freeType?.trim()
    //         const isHeaderType = type === "Header" || type === "subHeader";
    //         // Add this question if it has answer or freeType
    //         // if (hasAnswer || hasFreeType) {
    //         //     result.push({
    //         //         label,
    //         //         answer,
    //         //         freeType,
    //         //         freewayRemark: q.freewayRemark || '',
    //         //         historyOfDiagnosis: q.historyOfDiagnosis || undefined,
    //         //         parentQuestion: parentContext
    //         //             ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
    //         //             : undefined,
    //         //     });
    //         // }
    //         // Add question if it has an answer, freeType, or isOptionForFreeType is true
    //         const shouldInclude =
    //             (hasAnswer || hasFreeType || q?.isOptionForFreeType || q?.freewayRemark || isHeaderType) &&
    //             (!onlyWithHistoryOfDiagnosis || q?.historyOfDiagnosis === true)

    //         if (shouldInclude) {
    //             result.push({
    //                 id,
    //                 label,
    //                 answer,
    //                 freeType,
    //                 freewayRemark: q.freewayRemark || '',
    //                 historyOfDiagnosis: q.historyOfDiagnosis || undefined,
    //                 isOptionForFreeType: q?.isOptionForFreeType || false, 
    //                 parentQuestion: parentContext ? `${parentContext.label} - ${parentContext.selectedOptionLabel}` : undefined,
    //                 type
    //             })
    //         }

    //         // Now check options for linked questions
    //         for (const opt of options) {
    //             if (opt.linkedQuestion && opt.linkedQuestion.length > 0) {
    //                 console.log('nexte data linked data  ', opt.linkedQuestion, opt, options)
    //                 const nestedContext = {
    //                     label: answer,
    //                     selectedOptionLabel: opt.label,
    //                 }
    //                 const nestedResults = collectAllAnsweredQuestionsFromMerged(opt.linkedQuestion, nestedContext)
    //                 result.push(...nestedResults)
    //             }
    //         }
    //     }
    //     console.log("ressultttttt", result)

    //     return result
    // }


//     const isAnsweredQuestion = (q) => {
//     const hasAnswer = Array.isArray(q.answer)
//         ? q.answer.join(",").trim()
//         : q.answer?.trim();

//     const hasFreeType = q.freeType?.trim();

//     return Boolean(
//         hasAnswer ||
//         hasFreeType ||
//         q?.isOptionForFreeType ||
//         q?.freewayRemark
//     );
// };

// const collectAllAnsweredQuestionsFromMerged = (
//     questions,
//     parentContext = null,
//     onlyWithHistoryOfDiagnosis = false
// ) => {
//     console.log("incominngquestions", questions)
//     const result = [];

//     for (let i = 0; i < questions.length; i++) {
//         const q = questions[i];
//         const { id, label, answer, freeType, freewayRemark,  type } = q;
         
//         const isHeader = type === "Header" || type === "subHeader";

//        console.log("qData-->", q)
//         if (!isHeader) {
//             if (
//                 isAnsweredQuestion(q) &&
//                 (!onlyWithHistoryOfDiagnosis || q.historyOfDiagnosis === true)
//             ) {
//                 result.push({
//                     id,
//                     label,
//                     answer,
//                     freeType,
//                     freewayRemark: q.freewayRemark || "",
//                     historyOfDiagnosis: q.historyOfDiagnosis || undefined,
//                     isOptionForFreeType: q?.isOptionForFreeType || false,
//                     parentQuestion: parentContext
//                         ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
//                         : undefined,
//                     type,
//                 });
//             }
//             continue;
//         }

 
//         let shouldIncludeHeader = false;

//         for (let j = i + 1; j < questions.length; j++) {
//             const nextQ = questions[j];

      
//             if (
//                 nextQ.type === "Header" ||
//                 nextQ.type === "subHeader"
//             ) {
//                 break;
//             }

//             if (isAnsweredQuestion(nextQ)) {
//                 shouldIncludeHeader = true;
//                 break;
//             }
//         }

//         if (shouldIncludeHeader) {
//             result.push({
//                 id,
//                 label,
//                 answer,
//                 freeType,
//                 freewayRemark: q.freewayRemark || "",
//                 historyOfDiagnosis: q.historyOfDiagnosis || undefined,
//                 isOptionForFreeType: false,
//                 parentQuestion: parentContext
//                     ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
//                     : undefined,
//                 type,
//             });
//         }
//     }

//     return result;
// };


const isAnsweredQuestion = (q) => {
    const hasAnswer = Array.isArray(q.answer)
        ? q.answer.join(",").trim()
        : q.answer?.trim();

    const hasFreeType = q.freeType?.trim();

    return Boolean(
        hasAnswer ||
        hasFreeType ||
        q?.isOptionForFreeType ||
        q?.freewayRemark
    );
};

const collectAllAnsweredQuestionsFromMerged = (
    questions,
    parentContext = null,
    onlyWithHistoryOfDiagnosis = false,
    parentPath = [],
    optionLabel = ''
) => {
    const result = [];

    for (let i = 0; i < questions.length; i++) {
        const q = questions[i];
        const { id, label, answer, freeType, freewayRemark, type } = q;
        const currentPath = [...parentPath, createQuestionPathSegment(q, i, optionLabel)];
        const questionInstanceKey = q?.questionInstanceKey || getQuestionPathKey(currentPath);

        const isHeader = type === "Header" || type === "subHeader";

        // 🔹 NORMAL QUESTIONS
        if (!isHeader) {
            if (
                isAnsweredQuestion(q) &&
                (!onlyWithHistoryOfDiagnosis || q.historyOfDiagnosis === true)
            ) {
                result.push({
                    id,
                    label,
                    answer,
                    freeType,
                    questionInstanceKey,
                    freewayRemark: q.freewayRemark || "",
                    historyOfDiagnosis: q.historyOfDiagnosis || undefined,
                    isOptionForFreeType: q?.isOptionForFreeType || false,
                    parentQuestion: parentContext
                        ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
                        : undefined,
                    type,
                });
            }
            continue;
        }

        // 🔹 HEADER / SUBHEADER
        let hasAnsweredNextQuestion = false;

        for (let j = i + 1; j < questions.length; j++) {
            const nextQ = questions[j];

            // stop at next header/subheader
            if (
                nextQ.type === "Header" ||
                nextQ.type === "subHeader"
            ) {
                break;
            }

            if (isAnsweredQuestion(nextQ)) {
                hasAnsweredNextQuestion = true;
                break;
            }
        }

        const shouldIncludeHeader =
            hasAnsweredNextQuestion || Boolean(freeType?.trim()) || Boolean(freewayRemark?.trim());

        if (shouldIncludeHeader) {
            result.push({
                id,
                label,
                answer,
                freeType,
                questionInstanceKey,
                freewayRemark: freewayRemark || "",
                historyOfDiagnosis: q.historyOfDiagnosis || undefined,
                isOptionForFreeType: false,
                parentQuestion: parentContext
                    ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
                    : undefined,
                type,
            });
        }
    }

    return result;
};


 const UpdateCheckForStatusData = async(update) =>{
     let appointmentDetails = await getAllAppointmentsDetails('GET')
          
              let filterPatient = appointmentDetails && appointmentDetails.length > 0 && appointmentDetails.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled')  )
              console.log("filterPatient",filterPatient)
       
         if(filterPatient.length > 0 ){
            const selectedDate = convertDate(filterPatient[0]?.data?.StartTime)
            console.log("selected Data", selectedDate)
          const isDataFound = await checkIfDataAvailableData(selectedDate)
           if(isDataFound && Object.keys(isDataFound).length > 0 && filterPatient.length > 0 ){
                
           const appointmentsData = filterPatient[0]
           updatePatientData({existingPatientData: isDataFound?.JsonData ,providerId:appointmentsData?.current?.Provider.value, patientId: appointmentsData?.current?.Patient?.value , updates: update , id : isDataFound?.Id, date: selectedDate })
    
        }
      }
  }


    const handleSubmit2 = async () => {
        setSaving(true)
        console.log('finalHpiStructure')

        const buildHPIObject = () => {
            return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
                const collected = collectAllAnsweredQuestionsFromMerged(questions, null, false)
                if (collected.length > 0) {
                    acc[key] = collected
                }
                return acc
            }, {})
        }

        if (parseInt(noteID) === 0) {
            console.log('Note ID is 0. ')
            const buildNoteStructureHistoryofDiagnosis = () => {
                return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
                    const collected = collectAllAnsweredQuestionsFromMerged(questions, null, true)
                    console.log('collected=>', collected)
                    const filteredQuestions = collected.map((item) => ({
                        label: item.label,
                        answer: item.answer,
                        freeType: item.freeType,
                        parentQuestion: item.parentQuestion,
                        originalQuestion: item,
                        id: item.id,
                        questionInstanceKey: item.questionInstanceKey,
                        type: item?.type,
                        freewayRemark : item?.freewayRemark
                    }))

                    if (filteredQuestions.length > 0) {
                        acc[key] = filteredQuestions
                    }

                    return acc
                }, {})
            }

            const finalHpiForNoteIDZero = buildNoteStructureHistoryofDiagnosis()
            console.log(finalHpiForNoteIDZero, 'finalHpiForNoteIDZero for noteID 0')
            if (Object.keys(finalHpiForNoteIDZero).length > 0) {
                console.log('adding to historyOfDiagnosis for noteID 0', noteStructureRef.current)
                noteStructureRef.current = {
                    ...noteStructureRef.current,
                    historyOfDiagnosis: finalHpiForNoteIDZero,
                }
                console.log(noteStructureRef.current, 'noteStructureRef.current for noteID 0')
                console.log('adding to historyOfDiagnosis for noteID 0', noteStructureRef.current)

            }
        }



        const finalHpi = buildHPIObject()
        console.log(finalHpi, 'finalHpi sending  ')
        if (Object.keys(finalHpi).length === 0) {
            console.warn('No diagnosis has any answered data. Nothing to save.')
            // return;
        }

        let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
        let allData = JSON.parse(data?.d)
        const allPatientHpiData = allData?.Data?.map((item) => {
            console.log(patientID, Number(noteID), 'latestPatientHPISecondTimeNoteWithSubjective')
            return {
                Id: item?.Id,
                ...JSON.parse(item?.JsonData),
                CreatedAt: item?.CreatedAt,
            }
        })

        console.log('latestPatientHPISecondTimeNoteWithSubjective 2', allPatientHpiData)
        const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
        // const result = allPatientHpiData
        console.log("latest data HPI", result)
        const latestPatientHPISecondTimeNoteWithSubjective = result?.[patientID] || null



        if (latestPatientHPISecondTimeNoteWithSubjective) {
            //   const finalHpiStructure = {
            //     [patientID]: {
            //       [noteID]: {
            //         CCENTER: finalHpi,
            //         medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
            //         data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
            //         newFreeTypeText: newFreeTypeText || '',
            //       },
            //     },
            //   }

            const finalHpiStructure = {
                [patientID]: {
                    CCENTER: finalHpi,
                    globalFreeType: newFreeTypeText || '',
                },
            }
            console.log(finalHpiStructure, result, 'finalHpiStructure while note 0')

            await SaveExtra('UPDATE', 'CallCenterQuestions', JSON.stringify(finalHpiStructure), result?.Id)

            const hpidata = await fetchPatientFinalNoteDetails()
            await getQuestionForDiagnosis(hpidata)
        } else {
            let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
            let allData = JSON.parse(data?.d)
            const allPatientHpiData = allData?.Data?.map((item) => {
                return {
                    Id: item?.Id,
                    ...JSON.parse(item?.JsonData),
                    CreatedAt: item?.CreatedAt,
                }
            })

            if (patientID) {

                // const finalHpiStructure = {
                //   [patientID]: {
                //     [noteID]: {
                //       CCENTER: finalHpi,
                //       medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
                //       data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
                //       newFreeTypeText: newFreeTypeText || '',
                //     },
                //   },
                // }
                const finalHpiStructure = {
                    [patientID]: {
                        CCENTER: finalHpi,
                        globalFreeType: newFreeTypeText || '',
                    },
                }

                console.log(finalHpiStructure, 'finalHpiStructure update')
                await SaveExtra('INSERT', 'CallCenterQuestions', JSON.stringify(finalHpiStructure), '')

                const hpidata = await fetchPatientFinalNoteDetails()
                await getQuestionForDiagnosis(hpidata)
            }
        }

        await UpdateCheckForStatusData({POAC : true})
        setSaving(false)




    }





    const updateAnswerByPath = (questions, targetPath, updater) => {
        if (!Array.isArray(questions) || !targetPath?.length) return questions

        const [currentSegment, ...remainingPath] = targetPath

        return questions.map((q, index) => {
            if (!matchesQuestionPathSegment(q, index, currentSegment)) return q

            if (remainingPath.length === 0) {
                return updater(q)
            }

            if (!Array.isArray(q.options)) return q

            const nextSegment = remainingPath[0]

            return {
                ...q,
                options: q.options.map((opt) => {
                    if (nextSegment.optionLabel && opt.label !== nextSegment.optionLabel) return opt

                    const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []
                    if (!linkedQuestions.length) return opt

                    return {
                        ...opt,
                        linkedQuestion: updateAnswerByPath(linkedQuestions, remainingPath, updater),
                    }
                }),
            }
        })
    }

    // const renderQuestion = (item, parentKey, parentIdx, parentPath = []) => {
    //     const currentPath = [...parentPath, item.id]
    //     console.log(item, 'item render question')
    //     const isTopLevel = parentPath.length === 0
    //     return (
    //         <div key={item.id} className="mb-3">
    //             <div className="d-flex align-items-center gap-1 mb-2">
    //                 <p className="mb-0">{parentIdx + 1}.</p>
    //                 <CFormLabel className="mb-0">{item.label}</CFormLabel>
    //             </div>
    //             {item.type === 'dropdown' && (
    //                 <Select
    //                     isMulti={item?.isMultiple}
    //                     menuIsOpen={item?.isMultiple ? undefined : item?.menuIsOpen}
    //                     closeMenuOnSelect={!item?.isMultiple}

    //                     onChange={(selected) => {
    //                         console.log('Selected:', selected, 'for question:', item.label)
    //                         let selectedValues = ''
    //                         let selectedValuesArr = []
    //                         if (item?.isMultiple) {
    //                             selectedValuesArr = selected?.map((opt) => opt.value) || []
    //                             selectedValues = selectedValuesArr.join(', ')
    //                         } else {
    //                             selectedValues = selected?.value || ''
    //                         }

    //                         setQuestionsWithDiagnosis((prevData) => {
    //                             const newData = { ...prevData }
    //                             newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, answer: selectedValues }))
    //                             return newData
    //                         })
    //                     }}
    //                     value={
    //                         item?.isMultiple
    //                             ? item?.answer && item.answer.trim()
    //                                 ? item.answer.split(',').map((val) => ({
    //                                     value: val.trim(),
    //                                     label: val.trim(),
    //                                 }))
    //                                 : []
    //                             : item?.answer && item.answer.trim()
    //                                 ? { value: item.answer, label: item.answer }
    //                                 : null
    //                     }
    //                     options={
    //                         item.options?.map((opt) => ({
    //                             value: opt.label,
    //                             label: opt.label,
    //                         })) || []
    //                     }
    //                     placeholder="Select an option"
    //                     isClearable={!item?.isMultiple}
    //                 />
    //             )}
    //             {item.type === 'input' && (
    //                 <input
    //                     type="text"
    //                     className="form-control mt-2 "
    //                     value={item.answer || ''}
    //                     // style={{
    //                     //   backgroundColor: '#191919',
    //                     //   color: 'white',
    //                     //   border: '0.6px solid #989898',
    //                     // }}
    //                     onChange={(e) => {
    //                         const val = e.target.value
    //                         setQuestionsWithDiagnosis((prevData) => {
    //                             const newData = { ...prevData }
    //                             newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, answer: val }))
    //                             return newData
    //                         })
    //                     }}
    //                     placeholder="Enter your text"
    //                 />
    //             )}
    //             {item.providerInfo && <p className="  mt-2 text-warning"  >{item.providerInfo}</p>}
    //             {item.options?.map((opt) => {
    //                 let isSelected = false
    //                 if (item?.isMultiple) {
    //                     const answerArray = item?.answer ? item.answer.split(',').map((v) => v.trim()) : []
    //                     isSelected = answerArray.includes(opt.label)
    //                 } else {
    //                     isSelected = item?.answer === opt.label
    //                 }
    //                 const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

    //                 return (
    //                     isSelected &&
    //                     linkedQuestions?.length > 0 && (
    //                         <div key={`${opt.label}-${item.id}`} className="ml-3 mt-3 border-start ps-3">
    //                             {linkedQuestions.map((nestedItem, nestedIdx) => renderQuestion(nestedItem, parentKey, nestedIdx, currentPath))}
    //                         </div>
    //                     )
    //                 )
    //             })}
    //             {isTopLevel && (
    //                 <div className="mt-2">
    //                     <Graytextarea
    //                         value={item.freeType || ''}
    //                         onChange={(e) => {
    //                             const val = e.target.value
    //                             setQuestionsWithDiagnosis((prevData) => {
    //                                 const newData = { ...prevData }
    //                                 newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, freeType: val }))
    //                                 return newData
    //                             })
    //                         }}
    //                         style={{
    //                             border: '0.6px solid #989898',

    //                             height: '100px',

    //                             fontSize: '14px'
    //                         }}
    //                         placeholder="Freetype"
    //                     />
    //                 </div>
    //             )}
    //         </div>
    //     )
    // }


    const QUESTION_RENDER_FLOW = {
    Header: {
        className: "fw-bold fs-6 text-decoration-underline ui-form-question__heading",
        isAnswerable: false,
    },
    subHeader: {
        className: "fw-medium fs-7 ui-form-question__subheading",
        isAnswerable: false,
    },
    dropdown: {
        isAnswerable: true,
        component: "dropdown",
    },
    input: {
        isAnswerable: true,
        component: "input",
    },
    note: {
        className: "fst-italic ui-form-question__note",
        isAnswerable: false
    },
    divider: {
        className: "ui-form-question__divider my-2",
        isAnswerable: false
    }
};



 
 

 


 useEffect(() => {
  if (!questionsWithDiagnosis || !Array.isArray(questionsWithDiagnosis)) return;

  setQuestionsWithDiagnosis(prev => {
    const newData = { ...prev };

    Object.entries(questionsWithDiagnosis).forEach(([parentKey, items]) => {
      items.forEach(item => {
        const isHeader = item?.type === "Header" || item?.type === "subHeader";

        if (isHeader) {
          if (!Array.isArray(newData[parentKey])) newData[parentKey] = [];

          const exists = newData[parentKey].some(q => q.id === item.id);
          if (!exists) {
            newData[parentKey] = [
              ...newData[parentKey],
              { ...item, answer: "" }
            ];
          }
        }
      });
    });

    return newData;
  });
}, [questionsWithDiagnosis]);

 
 
    const renderQuestion =  (item, parentKey, parentIdx, parentPath = [], optionLabel = '') => {
        const currentPath = [...parentPath, createQuestionPathSegment(item, parentIdx, optionLabel)];
        const currentPathKey = getQuestionPathKey(currentPath);
        const isTopLevel = parentPath.length === 0;
        const isHeader = item?.type === "Header" ||  item?.type === 'subHeader'
        const isSubHeader = item?.type === 'subHeader';
         const flow =  QUESTION_RENDER_FLOW[item?.type]   
      
        console.log("item data" , item)
        return (
            <div key={currentPathKey} className={`mb-3 ui-form-question__item ${(isHeader) ? "p-1" : ""}`}>
                 {/* { item?.freewayRemark && <p style={{ whiteSpace: 'pre-wrap' }}>{item?.freewayRemark}</p>} */}

               <div className="d-flex align-items-center gap-1 mb-2">
                    <CFormLabel
                        className={`mb-0 ${flow.className || ""}`}
                    >
                        {item?.type === 'subHeader' ?` ${item.label} :`   : item.label}
                    </CFormLabel>
                </div>
 

                {flow.isAnswerable && item.type === 'dropdown' && (
                    <AppSelect
                        className={selectClassName}
                        isMulti={item?.isMultiple}
                        menuIsOpen={item?.isMultiple ? undefined : item?.menuIsOpen}
                        closeMenuOnSelect={!item?.isMultiple}
                        onChange={(selected) => {
                            let selectedValues = '';
                            let selectedValuesArr = [];

                            if (item?.isMultiple) {
                                selectedValuesArr = selected?.map((opt) => opt.value) || [];
                                selectedValues = selectedValuesArr.join(', ');
                            } else {
                                selectedValues = selected?.value || '';
                            }

                            setQuestionsWithDiagnosis((prevData) => {
                                const newData = { ...prevData };
                                newData[parentKey] = updateAnswerByPath(
                                    newData[parentKey],
                                    currentPath,
                                    (q) => ({ ...q, questionInstanceKey: currentPathKey, answer: selectedValues })
                                );
                                return newData;
                            });
                        }}
                        value={
                            item?.isMultiple
                                ? item?.answer && item.answer.trim()
                                    ? item.answer.split(',').map((val) => ({
                                        value: val.trim(),
                                        label: val.trim(),
                                    }))
                                    : []
                                : item?.answer && item.answer.trim()
                                    ? { value: item.answer, label: item.answer }
                                    : null
                        }
                        options={
                            item.options?.map((opt) => ({
                                value: opt.label,
                                label: opt.label,
                            })) || []
                        }
                        placeholder="Select an option"
                        isClearable={!item?.isMultiple}
                    />
                )}


              
                {flow.isAnswerable && item.type === 'input' && (
                    <HighLightText
                        value={item.answer || ""}
                        callingName={callingName}
                        onPaste={handleCallCenterPaste}
                        onChange={(htmlValue) => {
                            setQuestionsWithDiagnosis((prevData) => {
                                const newData = { ...prevData };
                                newData[parentKey] = updateAnswerByPath(
                                    newData[parentKey],
                                    currentPath,
                                    (q) => ({ ...q, questionInstanceKey: currentPathKey, answer: htmlValue }) // store HTML
                                );
                                return newData;
                            });
                        }}
                    />
                )}


                {item.providerInfo && <p className="mt-2 ui-form-question__provider-info">{item.providerInfo}</p>}


                {flow.isAnswerable && item.options?.map((opt) => {
                    let isSelected = false;

                    if (item?.isMultiple) {
                        const answerArray = item?.answer ? item.answer.split(',').map((v) => v.trim()) : [];
                        isSelected = answerArray.includes(opt.label);
                    } else {
                        isSelected = item?.answer === opt.label;
                    }

                    const linkedQuestions = Array.isArray(opt.linkedQuestion)
                        ? opt.linkedQuestion
                        : opt.linkedQuestion
                            ? [opt.linkedQuestion]
                            : [];

                    return (
                        isSelected &&
                        linkedQuestions.length > 0 && (
                            <div key={`${currentPathKey}-${opt.label}`} className="mt-3 ps-3 ui-form-question__nested">
                                {linkedQuestions.map((nestedItem, nestedIdx) =>
                                    renderQuestion(nestedItem, parentKey, nestedIdx, currentPath, opt.label)
                                )}
                            </div>
                        )
                    );
                })}


                {isTopLevel && flow.isAnswerable && item.type === 'dropdown' && (
                   
                    <div className="mt-2">
                         <HighLightText
                        value={item.freeType || ''}
                        callingName={callingName}
                        onPaste={handleCallCenterPaste}
                        onChange={(val) => {  // val is already the content
                            setQuestionsWithDiagnosis((prevData) => {
                                const newData = { ...prevData };
                                newData[parentKey] = updateAnswerByPath(
                                    newData[parentKey],
                                    currentPath,
                                    (q) => ({ ...q, questionInstanceKey: currentPathKey, freeType: val }) // use val directly
                                );
                                return newData;
                            });
                        }}
                        
                        type="textarea"
                        placeholder="Freetype"
                    />
                    </div>

                )}
                { 
                    (item.type === 'Header' || item.type === 'subHeader') && (
                        <div className="mt-2">
                            <HighLightText
                                value={item.freeType || ''}
                                callingName={callingName}
                                onPaste={handleCallCenterPaste}
                                onChange={(val) => {
                                    setQuestionsWithDiagnosis((prevData) => {
                                        const newData = { ...prevData };
                                        newData[parentKey] = updateAnswerByPath(
                                            newData[parentKey],
                                            currentPath,
                                            (q) => ({ ...q, questionInstanceKey: currentPathKey, freeType: val })
                                        );
                                        return newData;
                                    });
                                }}
                                type="textarea"
                                placeholder="Provider Remark"
                            />
                        </div>
                    )
                }

            </div>
        );
    };



    

    return (
        <>
            <div className={questionShellClassName}>
                <CButton onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setFreeTypeModal((p) => !p)
                }} className="ui-action-btn ui-action-btn--primary ui-form-question-shell__freetype-button">
                    Add Free Type
                </CButton>

                {!fetchingQuestions ? (
                    <div className="d-flex flex-column gap-2">
                         {newFreeTypeText && <p className="ui-form-question-shell__global-note">{newFreeTypeText || ''}</p>}
                        {Object.entries(questionsWithDiagnosis)
                            //   .filter(([key, value]) => !(value[0]?.isOptionForFreeType)) // <-- skip if true
                            .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
                            .map(([key, value], index) => {
                                console.log(key, value, 'questionsWithDiagnosis with diagnosis and questions')
                                const diagnosisRemark = getDiagnosisRemarkText(key, value)
                                return (
                                    <CAccordion key={index} alwaysOpen className="patient-theme-accordion ui-form-question-accordion">
                                        <CAccordionItem itemKey={1} className="ui-form-question-accordion__item">
                                            <CAccordionHeader>
                                                <div className="d-flex justify-content-between align-items-center gap-2 w-100">
                                                    <p className="p-0 m-0 ui-form-question-accordion__title">{key}</p>
                                                    <span
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            e.preventDefault()

                                                        }}
                                                        className="ui-form-question-accordion__trigger"
                                                    >
                                                        
                                                        <span
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                e.preventDefault()
                                                                openDiagnosisRemarkModal(key, value)
                                                            }}
                                                            className="ui-form-question-accordion__icon"
                                                        >
                                                            <FilePlus2 size={18} />
                                                        </span>
                                                    </span>

                                                </div>
                                            </CAccordionHeader>
                                            <CAccordionBody className="ui-form-question-accordion__body">
                                                
                                             {diagnosisRemark && <p className='mb-0 m-0 ui-form-question-accordion__remark'>{diagnosisRemark}</p>}
                                                {value?.map((item, idx) => item?.isOptionForFreeType ? null : renderQuestion(item, key, idx))}
                                            </CAccordionBody>
                                        </CAccordionItem>
                                    </CAccordion>
                                )
                            })}
                    </div>
                ) : (
                    <p className="ui-form-question-shell__loading">Loading...</p>
                )}
                <div className="d-flex justify-content-center mt-2">
                    <CButton
                        onClick={handleSubmit2}
                        className="ui-action-btn ui-action-btn--primary ui-form-question-shell__save"
                    >
                        {saving ? <CSpinner size="sm" aria-hidden="true" /> : 'Save'}
                    </CButton>
                </div>
            </div>



 <CModal className="patient-theme-modal ui-form-question-modal" visible={freeTypeModal} size="lg" alignment="center" onClose={() => setFreeTypeModal(false)}>
        <CModalHeader
          className="justify-content-center"
        >
          <CModalTitle className="w-100 ui-form-question-modal__title">Add Freetype</CModalTitle>
        </CModalHeader>

        <CModalBody>
          <Graytextarea
            placeholder="Enter freetype"
            value={tempFreeTypeText}
            rows={4}
            onChange={(e) => setTempFreeTypeText(e.target.value)}
            style={{
              height: '200px',
            }}
          />
        </CModalBody>

        <CModalFooter
          className="justify-content-center gap-2 ui-form-question-modal__footer"
        >
          <CButton
            color="secondary"
            variant="outline"
            className="ui-action-btn ui-action-btn--secondary ui-form-question-modal__button"
            onClick={() => {
              setFreeTypeModal(false)
              setTempFreeTypeText('')
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              setFreeTypeModal(false)
              setNewFreeTypeText(tempFreeTypeText)
            }}
            className="ui-action-btn ui-action-btn--primary ui-form-question-modal__button"
          >
            Add
          </CButton>
        </CModalFooter>
      </CModal>

          <CModal
              className="patient-theme-modal ui-form-question-modal"
              backdrop="static"
              centered
              visible={selectedDiagnosiToAddFreeTypeRemarks !== ''}
              size="lg"
              alignment="center"
              onClose={closeDiagnosisRemarkModal}
            >
              <CModalHeader
                className="justify-content-center"
                onClose={closeDiagnosisRemarkModal}
              >
                <CModalTitle
                  className="w-100 ui-form-question-modal__title"
                  id="LiveDemoExampleLabel"
                >
                  Add Free remarks to {selectedDiagnosiToAddFreeTypeRemarks ? selectedDiagnosiToAddFreeTypeRemarks : ''}
                </CModalTitle>
              </CModalHeader>
              <CModalBody className="ui-form-question-modal__body">
                <div>
                  <Graytextarea
                    value={freeTypeRemarksText}
                    onChange={(e) => {
                      setFreeTypeRemarksText(e.target.value)
                    }}
      
                    style={{
                      height: '200px',
                    }}
                  />
                </div>
              </CModalBody>
              <CModalFooter
                className="justify-content-center gap-2 ui-form-question-modal__footer"
              >
               
                <CButton
                  color="secondary"
                  variant="outline"
                  className="ui-action-btn ui-action-btn--secondary ui-form-question-modal__button"
                  onClick={closeDiagnosisRemarkModal}
                >
                  Close
                </CButton>
                <CButton
                  color="primary"
                  className="ui-action-btn ui-action-btn--primary ui-form-question-modal__button"
                  onClick={handleSaveDiagnosisRemark}
                >
                  Save
                </CButton>
              </CModalFooter>
            </CModal>
        </>
    )
}

export default FormQuestionRender
